import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'wsb-email-dns-new-modal',
  templateUrl: './email-dns-new-modal.component.html',
  styleUrls: ['./email-dns-new-modal.component.scss'],
  standalone: false
})
export class EmailDnsNewModalComponent implements OnInit, AfterViewInit {
  @ViewChild(ToastContainerDirective) modalToastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  @Input() public title;
  @Input() public text;
  @Input() public alertText;
  @Input() public placeholder;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public labelSaveButton = 'common_ok';

  @Output() add: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  newDnsForm: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal, private atlasToast: AtlasToastService) {}

  ngOnInit(): void {
    this.newDnsForm = this.buildNewDnsForm();
  }

  ngAfterViewInit(): void {
    const text = this.alertText;
    this.atlasToast.info(text, '', -1, this.toastContainer);
  }

  private buildNewDnsForm() {
    return this.formBuilder.group({
      domainName: this.formBuilder.control('', [Validators.required])
    });
  }

  private get(value) {
    return this.newDnsForm.get(value).value;
  }

  getFormValue() {
    return {
      domain: this.get('domainName')
    };
  }
}
